import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center s:justify-start" }
const _hoisted_2 = { class: "flex gap-x-2 items-center bg-satin rounded-3xl p-1" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "font-serif title-terra text-lg font-medium mt-6 mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "divide-y divide-merinos-100 max-h-64 overflow-y-auto"
}
const _hoisted_8 = { class: "form-control flex items-center gap-x-2 py-4" }
const _hoisted_9 = {
  for: "ALL",
  class: "text-merinos-800 font-bold leading-6 cursor-pointer"
}
const _hoisted_10 = ["id", "value", "checked", "disabled"]
const _hoisted_11 = ["for"]
const _hoisted_12 = {
  key: 1,
  class: "divide-y divide-merinos-100 max-h-64 overflow-y-auto"
}
const _hoisted_13 = { class: "form-control flex items-center gap-x-2 py-4" }
const _hoisted_14 = {
  for: "ALL",
  class: "text-merinos-800 font-bold leading-6 cursor-pointer"
}
const _hoisted_15 = ["id", "value", "checked", "disabled"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "flex gap-x-4 py-4 max-w-6xl overflow-x-auto" }
const _hoisted_19 = ["value", "checked"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "text-merinos-800 leading-6 font-medium inline-block text-center my-4 px-3 peer-checked:text-terra-900 peer-checked:font-bold" }

import { computed, ref, watch } from 'vue';

  
export default {
  __name: 'Destination',
  props: {
    modelValue: {
      type: Array,
    },
    destinationType: String,
    france: {
      type: Array,
      default: () => ([])
    },
    nearTo: {
      type: Array,
      default: () => ([])
    },
    envie: {
      type: Array,
      default: () => ([])
    },
    trad: {
      type: Object,
      required: true
    },
  },
  emits: ['update:modelValue', 'change-type'],
  setup(__props, { emit: __emit }) {

  const emit = __emit

  const props = __props

  const INDEXES = {
    'france': 0,
    'proche-de': 1,
    'envie': 2,
  }
  const currentTabIndex = ref(INDEXES[props.destinationType]);
  const value = ref(props.modelValue);

  watch(value, (newValue) => {
    emit('update:modelValue', newValue);
  })

  const isDisablingTabs = computed(() => {
    if (props.modelValue.length > 0) {
      return true
    }

    // Return `undefined` to remove the `disabled` attribute.
    return undefined;
  })

return (_ctx, _cache) => {
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("button", {
            disabled: __props.destinationType !== 'france' && isDisablingTabs.value,
            class: _normalizeClass(["rounded-[19px] font-bold px-4 py-2 transition disabled:cursor-not-allowed", {
              'text-merinos-800 bg-merinos-50 shadow': currentTabIndex.value === INDEXES.france,
              'text-merinos-400': currentTabIndex.value !== INDEXES.france,
            }]),
            onClick: _cache[0] || (_cache[0] = $event => (currentTabIndex.value = INDEXES.france))
          }, _toDisplayString(__props.trad.remote_destination), 11 /* TEXT, CLASS, PROPS */, _hoisted_3)
        ])), [
          [_vShow, __props.trad.search_taxonomies_enabled.some((taxonomy) => taxonomy.value === 'france')],
          [_directive_tooltip, {
            content: __props.trad.disabled_destination_tab,
            disabled: __props.modelValue.length === 0 || (isDisablingTabs.value && !(currentTabIndex.value !== INDEXES.france)),
          }]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("button", {
            disabled: __props.destinationType !== 'proche-de' && isDisablingTabs.value,
            class: _normalizeClass(["rounded-[19px] font-bold px-4 py-2 transition disabled:cursor-not-allowed", {
              'text-merinos-800 bg-merinos-50 shadow': currentTabIndex.value === INDEXES['proche-de'],
              'text-merinos-400': currentTabIndex.value !== INDEXES['proche-de'],
            }]),
            onClick: _cache[1] || (_cache[1] = $event => (currentTabIndex.value = INDEXES['proche-de']))
          }, _toDisplayString(__props.trad.remote_near_to), 11 /* TEXT, CLASS, PROPS */, _hoisted_4)
        ])), [
          [_vShow, __props.trad.search_taxonomies_enabled.some((taxonomy) => taxonomy.value === 'proche-de')],
          [_directive_tooltip, {
            content: __props.trad.disabled_destination_tab,
            disabled: __props.modelValue.length === 0 || (isDisablingTabs.value && !(currentTabIndex.value !== INDEXES['proche-de'])),
          }]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("button", {
            disabled: __props.destinationType !== 'envie' && isDisablingTabs.value,
            class: _normalizeClass(["rounded-[19px] font-bold px-4 py-2 disabled:cursor-not-allowed", {
              'text-merinos-800 bg-merinos-50 shadow': currentTabIndex.value === INDEXES.envie,
              'text-merinos-400': currentTabIndex.value !== INDEXES.envie,
            }]),
            onClick: _cache[2] || (_cache[2] = $event => (currentTabIndex.value = INDEXES.envie))
          }, _toDisplayString(__props.trad.remote_envie), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
        ])), [
          [_vShow, __props.trad.search_taxonomies_enabled.some((taxonomy) => taxonomy.value === 'envie')],
          [_directive_tooltip, {
            content: __props.trad.disabled_destination_tab,
            disabled: __props.modelValue.length === 0 || (isDisablingTabs.value && !(currentTabIndex.value !== INDEXES.envie)),
          }]
        ])
      ])
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(__props.trad.remote_question) + " " + _toDisplayString((currentTabIndex.value === INDEXES.france) || (currentTabIndex.value === INDEXES['proche-de']) ? __props.trad.remote_destination?.toLowerCase() : __props.trad.remote_envie?.toLowerCase()) + " ? ", 1 /* TEXT */),
    (currentTabIndex.value === INDEXES.france)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "ALL",
              value: "ALL",
              name: "destination",
              class: "cursor-pointer",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((value).value = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, value.value]
            ]),
            _createElementVNode("label", _hoisted_9, _toDisplayString(__props.trad.remote_all_regions), 1 /* TEXT */)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.france, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `france-${item.id}`,
              class: _normalizeClass(["form-control flex items-center gap-x-2 py-4", {
          'form-control--disabled': __props.modelValue.includes('ALL'),
        }])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: `france-${item.id}`,
                name: "destination",
                value: item.id,
                class: "cursor-pointer",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((value).value = $event)),
                checked: __props.modelValue.includes(item.id) ? true : false,
                disabled: __props.modelValue.includes('ALL') ? true : undefined,
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.$emit('change-type', 'france')))
              }, null, 8 /* PROPS */, _hoisted_10), [
                [_vModelCheckbox, value.value]
              ]),
              _createElementVNode("label", {
                for: `france-${item.id}`,
                class: "text-merinos-800 font-medium leading-6 cursor-pointer"
              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_11)
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (currentTabIndex.value === INDEXES['proche-de'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "ALL",
              value: "ALL",
              name: "destination",
              class: "cursor-pointer",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((value).value = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, value.value]
            ]),
            _createElementVNode("label", _hoisted_14, _toDisplayString(__props.trad.remote_all_near_to), 1 /* TEXT */)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.nearTo, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `nearTo-${item.id}`,
              class: _normalizeClass(["form-control flex items-center gap-x-2 py-4", {
          'form-control--disabled': __props.modelValue.includes('ALL'),
        }])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: `nearTo-${item.id}`,
                name: "destination",
                value: item.id,
                class: "cursor-pointer",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((value).value = $event)),
                checked: __props.modelValue.includes(item.id) ? true : false,
                disabled: __props.modelValue.includes('ALL') ? true : undefined,
                onClick: _cache[8] || (_cache[8] = $event => (_ctx.$emit('change-type', 'proche-de')))
              }, null, 8 /* PROPS */, _hoisted_15), [
                [_vModelCheckbox, value.value]
              ]),
              _createElementVNode("label", {
                for: `nearTo-${item.id}`,
                class: "text-merinos-800 font-medium leading-6 cursor-pointer"
              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_16)
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (currentTabIndex.value === INDEXES.envie)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.envie, (item) => {
              return (_openBlock(), _createElementBlock("label", {
                key: item.id,
                class: "relative rounded-3xl bg-satin overflow-hidden text-center min-w-[9rem]"
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "peer appearance-none absolute inset-0 border border-merinos-100 checked:border-2 checked:border-terra-900 rounded-3xl hover:border-terra-900 transition cursor-pointer w-full h-full",
                  type: "checkbox",
                  name: "destination",
                  value: item.id,
                  checked: __props.modelValue.includes(item.id) ? true : false,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((value).value = $event)),
                  onClick: _cache[10] || (_cache[10] = $event => (_ctx.$emit('change-type', 'envie')))
                }, null, 8 /* PROPS */, _hoisted_19), [
                  [_vModelCheckbox, value.value]
                ]),
                _createElementVNode("img", {
                  src: item.acf?.thumb_image?.url ?? 'https://placehold.co/200x200',
                  alt: item.name,
                  height: "128",
                  width: "144",
                  loading: "lazy",
                  class: "h-32 w-36 object-cover"
                }, null, 8 /* PROPS */, _hoisted_20),
                _createElementVNode("span", _hoisted_21, _toDisplayString(item.name), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}